import angular from 'angular';
import { NewRsPayoutTransferComponent } from './new-rs-payout-transfer.component';
import { RsPayoutTransfersListComponent } from './rs-payout-transfers-list.component';

/**
 * A module containing components used to transfer payout amounts
 * from one owner's RS schedule to another owner.
 */
export const RsPayoutTransferModule = angular
    .module("apex.mainApp.rsPayoutTransfer", [])
    .component("apexNewRsPayoutTransfer", NewRsPayoutTransferComponent)
    .component("apexRsPayoutTransfersList", RsPayoutTransfersListComponent)
    .name;
